import {Typography} from "@mui/material";

export const SubscriberInfoContent = () => {


    return {
        title: 'Subscribers',
        content: (
            <>
                <Typography paragraph>
                    Subscriber records contain subscriber counts by date
                    for distribution platforms such as Pay TV, SVOD,
                    AVOD, FAST channels, and other subscription-based
                    services.
                </Typography>

                <ul>
                    <li>
                        Subscriber data is commonly used to calculate
                        obligations, royalties, participations, and
                        residuals that depend on subscriber-based
                        metrics.
                    </li>

                    <li>
                        Each record typically represents the subscriber
                        count for a specific Platform, Service, and
                        reporting date.
                    </li>

                    <li>
                        Subscriber information may be sourced from
                        platform reporting, industry reporting services,
                        or internally maintained data.
                    </li>

                    <li>
                        Historical subscriber counts are often retained
                        to support audits, recalculations, and trend
                        analysis.
                    </li>

                    <li>
                        Use the <strong>Search</strong> (magnifying glass)
                        to locate existing Subscriber records.
                    </li>

                    <li>
                        Use the <strong>Upload</strong> button to import
                        Subscriber data from external files.
                    </li>

                    <li>
                        Use the <strong>Add</strong> (+) button to create
                        a new Subscriber record manually.
                    </li>

                    <li>
                        Use the row menu on the left side of the grid
                        to clone, edit, or delete Subscriber records.
                    </li>

                    <li>
                        Maintaining accurate Subscriber data helps ensure
                        that subscriber-based calculations and reporting
                        reflect the correct platform audience size for
                        each reporting period.
                    </li>
                </ul>
            </>
        )
    };

};






